import {
    ADD_TEAM_MEMBERS_FAILURE,
    ADD_TEAM_MEMBERS_SUCCESS,
    ADD_TEAM_MEMBERS_REQUEST,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addTeamMembersByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TEAM_MEMBERS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_TEAM_MEMBERS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_TEAM_MEMBERS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addTeamMembersByAdminReducer;
